module.exports = __webpack_public_path__ + "img/cooperate_7.fab08a83.png";